<template>
<form id="payman_form" class="border p-2"  @submit.prevent="submit">
<kt-row>
    <kt-col xs="12" class="mb-5">
        <img :src="payman.logo" style="max-width:300px" class="d-block m-auto">
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="farsi_name">
                {{ $t('label.farsi_name') }}
            </kt-form-label>
            <kt-form-control
                id="farsi_name"
                name="farsi_name"
                v-model="payman.farsi_name"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="english_name">
                {{ $t('label.english_name') }}
            </kt-form-label>
            <kt-form-control
                id="english_name"
                name="english_name"
                v-model="payman.english_name"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="payman_sequence">
                {{ $t('label.gateway_id') }}
            </kt-form-label>
            <kt-form-control
                id="payman_sequence"
                name="payman_sequence"
                disabled
                :value="payman.sequence"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="created_at">
                {{ $t('label.created_at') }}
            </kt-form-label>
            <kt-form-control
                id="created_at"
                name="created_at"
                disabled
                :value="payman.created_at"
                dir="ltr"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="category_code">
                {{ $t('label.subcategory_code') }}
            </kt-form-label>
            <select
                id="category_code"
                name="category_code"
                v-model="payman.category_code"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="category.key"
                    v-for="category in categories"

                    :value="category.key"
                >
                    {{ category.value }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>
    
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="address_id">
                {{ $t('label.address') }}
            </kt-form-label>
            <select
                v-if="addresses"
                id="address_id"
                name="address_id"
                v-model="payman.address_id"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="address.id"
                    v-for="address in addresses"
                    :value="address.id"
                >
                    {{ address.address }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="postal_code">
                {{ $t('label.postal_code') }}
            </kt-form-label>
            <kt-form-control
                id="postal_code"
                name="postal_code"
                disabled
                :value="payman.postal_code"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="telephone">
                {{ $t('label.telephone') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="telephone"
                name="telephone"
                v-model="payman.phone_number"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="sheba_id">
                {{ $t('label.sheba_number') }}
            </kt-form-label>
            <select
                id="sheba_id"
                name="sheba_id"
                v-model="payman.sheba_id"
                class="form-control kt-selectpicker"
            >
                <option 
                    v-bind:key="sheba_number.id"
                    v-for="sheba_number in sheba_numbers"
                    :value="sheba_number.id"
                >
                    {{ sheba_number.number }}
                </option>
            </select>
        </kt-form-group>
    </kt-col>
    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="site_address">
                {{ $t('label.site_address') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="site_address"
                name="site_address"
                v-model="payman.website_address"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-group>
            <kt-form-label for="server_ip">
                {{ $t('label.server_ip') }}
            </kt-form-label>
            <kt-form-control
                dir="ltr"
                id="server_ip"
                name="server_ip"
                disabled
                :value="payman.server_ip"
            >
            </kt-form-control>
        </kt-form-group>
    </kt-col>

    <kt-col xs="12">
        <kt-form-action class="mt-4">
            <kt-button 
                class="m-2"
                size="md"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="submit_btn"
            >
                {{ $t('panel.profile.update.wizard.form.btn.submit') }}
            </kt-button>
        </kt-form-action>
    </kt-col>
</kt-row>
</form>
</template>

<script>
import $ from 'jquery';
import { subcategories } from '@/constants/subcategories';
import { wages } from '@/constants/wageStatus';
import { KTApp } from '@/plugins/core/app';
import { KTUtil } from '@/plugins/core/util';
import { paymanService } from '@/common/api.service';
import { i18n } from '@/plugins/i18n';
import Inputmask from "inputmask";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            categories: subcategories,
            'hashid': this.$route.params.hashid,
        };
    },
    props: {
        payman: {
            required: true,
        }
    },
    computed: {
        ...mapGetters('address', [
            'addresses'
        ]),
        ...mapGetters('shebaNumber', [
            'sheba_numbers'
        ])
    },
    mounted() {
        this.$store.dispatch('shebaNumber/fetchByShopId', {
            'hashid': this.hashid,
            'shop_type': 1
        }).finally(() => {
            Object.keys(this.sheba_numbers).map(key => {
                let number = this.sheba_numbers[key]['number'] == null ? '' : 'IR'+this.sheba_numbers[key]['number'].split('-').join('')
                this.sheba_numbers[key]['number'] = number
            });

            this.$store.dispatch('address/fetchByShopId', {
                'hashid': this.hashid,
                'shop_type': 1
            }).finally(() => {
                this.afterDispatch();
            });
        });
    },
    methods: {
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
            document.getElementById('telephone') && Inputmask('099-99999999').mask(document.getElementById('telephone'));
        },
        submit(e) {

            let form = $('#payman_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    category_code: {
                        required: true,
                    },
                    phone_number: {
                        required: true
                    },
                    address_id: {
                        required: true
                    },
                    sheba_id: {
                        required: true
                    },
                    website_address: {
                        required: true,
                        url: true
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)


            let params = this.$store.getters['payman/form_data']
            // let form_data = new FormData
            
            paymanService.updateByAdmin(this.hashid, params).then(response => {
                this.showMsg(form, 'success', response.data.message);
                KTUtil.scrollTop();
            })
            .catch(({response}) => {
                if(response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            })
            .finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
}
</script>

<style scoped>
</style>